import {
    ADD_WEEK_PLANNER_REQUEST,
    ADD_WEEK_PLANNER_SUCCESS,
    UPDATE_WEEK_PLANNER_REQUEST,
    UPDATE_WEEK_PLANNER_SUCCESS
  } from "../Constants";
    
    export default (state = {}, action) => {
      switch (action.type) {
        case  ADD_WEEK_PLANNER_REQUEST:
          return {
            ...state,
            isFetching: action.isFetching
          };
        case ADD_WEEK_PLANNER_SUCCESS:
          return {
            ...state,
            isFetching: action.isFetching,
            securityList: action.securityList
          };
          case UPDATE_WEEK_PLANNER_REQUEST:
          return {
            ...state,
            isFetching: action.isFetching,
            securityList: action.securityList
          };
          case UPDATE_WEEK_PLANNER_SUCCESS:
          return {
            ...state,
            isFetching: action.isFetching,
            securityList: action.securityList
          };
        default:
          return state;
      }
    };
    